import React from 'react'
import './myProjects.css'
import Nav from '../../globalComponents/nav/Nav'
import ClaimedProjects from './myProjectsComponents/ClaimedProjects'
import PostedProjects from './myProjectsComponents/PostedProjects'
import Footer from '../../globalComponents/footer/Footer';

function MyProjects() {
    return (
        <>
            <Nav></Nav>
            <div className='  main-container'>
                <h1>My Posted Projects</h1>
                
                    <PostedProjects></PostedProjects>
                <br />    
                <h1>Projects I Claimed</h1>

                    <ClaimedProjects></ClaimedProjects>

            </div>
        <Footer/>
        </>
    )
}

export default MyProjects
